import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import translate from '../../../commonComponents/translate';
import { OPPORTUNITIES_STATUS } from '../components/helpers/opportunitiesListHelper';
import OrderProp from '../../shop/propTypes/orderProp';

function InformationSection(props) {
  const { t, opportunity, isLoading, onExportPDF } = props;
  const { status } = opportunity;

  const headerTitle = useMemo(() => {
    let title = t('opportunity.information.header');
    if (
      status === OPPORTUNITIES_STATUS.APPROVED ||
      status === OPPORTUNITIES_STATUS.PAID
    ) {
      title = t('opportunity.preview.approved');
    }
    if (status === OPPORTUNITIES_STATUS.REJECTED) {
      title = t('opportunity.preview.rejected');
    }
    return title;
  }, [t, status]);

  return (
    <div className="information-section">
      <p className="header">{headerTitle}</p>
      <button
        className="header btn btn-sm btn-pdf-export"
        type="button"
        onClick={onExportPDF}
        disabled={isLoading}
      >
        {t('export.in.pdf')}
      </button>
    </div>
  );
}

InformationSection.propTypes = {
  t: PropTypes.func.isRequired,
  opportunity: PropTypes.shape(OrderProp.propType).isRequired,
  isLoading: PropTypes.bool.isRequired,
  onExportPDF: PropTypes.func.isRequired,
};

export default translate(InformationSection);
